





import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

@Component
export default class JdhLogicalRichRadioGroup extends Vue {
    @Prop() value!: string

    @ActiveProvide('jds.rich-radio.bus') bus: Vue|null = null
    @ActiveProvide('jds.rich-radio.value') currentValue: string|null = null

    beforeMount() {
        this.bus = new Vue()
        this.bus.$on('input', (value: string) => {
            this.$emit('input', value)
        })
    }

    @Watch('value', {immediate: true})
    syncValue() {
        this.currentValue = this.value
    }

}
